module.exports = __webpack_public_path__ + "static/media/saoa2.66890670.png";